import { SelectedTabType } from "./index";
import { ConfirmDialogType } from "../../../types/global";

export const initialDialogs: ConfirmDialogType = {
  open: false,
  submit: null,
  id: null,
  title: "",
  msg: "",
};

export interface NavigatePageType {
  key: SelectedTabType[];
  current: string;
  history: string[];
}

export const InitialNavigatePage: NavigatePageType = {
  key: ["home"],
  current: "home",
  history: [],
};
